import 'css-chunk:src/components/UploadButton.module.scss';export default {
  "overlay": "_overlay_1js1a_1",
  "modal-fade": "_modal-fade_1js1a_1",
  "modal": "_modal_1js1a_20",
  "modal-zoom": "_modal-zoom_1js1a_1",
  "field": "_field_1js1a_32"
};